import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PdfToTableComponent } from './pdf-to-table/pdf-to-table.component';
import { HttpClientModule } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { HomeComponent } from './home/home.component';
import { GettingStartedComponent } from './getting-started/getting-started.component';
import { DocumentationComponent } from './documentation/documentation.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactComponent } from './contact/contact.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { DiscussComponent } from './discuss/discuss.component';
import { DisqusModule } from "ngx-disqus";
import { StillquestionsComponent } from './stillquestions/stillquestions.component';

const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'Home', component: HomeComponent},
  { path: 'Convert', component: PdfToTableComponent },
  { path: 'GettingStarted', component: GettingStartedComponent },
  { path: 'Documentation', component: DocumentationComponent },
  { path: 'AboutUs', component: AboutUsComponent },
  { path: "Contact", component: ContactComponent },
  { path: "Discuss", component: DiscussComponent },
  { path: '**', component: PageNotFoundComponent }
];


@NgModule({
  declarations: [
    AppComponent,
    PdfToTableComponent,
    HomeComponent,
    GettingStartedComponent,
    DocumentationComponent,
    AboutUsComponent,
    ContactComponent,
    PageNotFoundComponent,
    DiscussComponent,
    StillquestionsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule, 
    HttpClientModule,
    ModalModule.forRoot(),
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    ),
    DisqusModule.forRoot("pdf-to-table")
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
